// extracted by mini-css-extract-plugin
export default {"TransactionsList":"TransactionsList_TransactionsList__LFaUF"};